import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, TranslateModule],
  template: `
    <p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '600px' }" [draggable]="false" 
              [resizable]="false" (visibleChange)="onVisibleChange()">
      <div class="text-center">
        <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M58.259 26.9547L20.4148 92.4981C19.7312 93.6817 19.3712 95.0244 19.3711 96.3913C19.371 97.7581 19.7307 99.1009 20.4141 100.285C21.0974 101.468 22.0804 102.451 23.2641 103.135C24.4479 103.818 25.7907 104.178 27.1575 104.178H102.84C104.207 104.178 105.549 103.818 106.733 103.135C107.917 102.451 108.9 101.468 109.583 100.285C110.267 99.1009 110.626 97.7581 110.626 96.3913C110.626 95.0244 110.266 93.6817 109.583 92.4981L71.7424 26.9547C71.0592 25.7713 70.0764 24.7886 68.893 24.1054C67.7096 23.4222 66.3672 23.0625 65.0007 23.0625C63.6342 23.0625 62.2918 23.4222 61.1084 24.1054C59.925 24.7886 58.9423 25.7713 58.259 26.9547Z" fill="#EE404C"/>
          <path d="M65.4934 47.1719H64.5062C62.0757 47.1719 60.1055 49.1421 60.1055 51.5726V72.6072C60.1055 75.0376 62.0757 77.0079 64.5062 77.0079H65.4934C67.9238 77.0079 69.8941 75.0376 69.8941 72.6072V51.5726C69.8941 49.1421 67.9238 47.1719 65.4934 47.1719Z" fill="#FFF7ED"/>
          <path d="M64.9998 93.6909C67.7028 93.6909 69.8941 91.4997 69.8941 88.7966C69.8941 86.0936 67.7028 83.9023 64.9998 83.9023C62.2967 83.9023 60.1055 86.0936 60.1055 88.7966C60.1055 91.4997 62.2967 93.6909 64.9998 93.6909Z" fill="#FFF7ED"/>
        </svg>   
        <p class="title">{{ resolvedTitle }}</p>
        <p class="text">{{ resolvedMessage }}</p>
        <div class="btns-group-flex justify-content-center mt-4">
          <button class="btn btn-outline-secondary" (click)="onClose()">{{ isCancel ? ('COMMON.CANCEL' | translate) : ('COMMON.OK' | translate) }}</button>
          <button class="btn btn-action" *ngIf="showRetry" (click)="onRetry()">{{ 'COMMON.RETRY' | translate }}</button>
        </div>

      </div>
    </p-dialog>
  `
})
export class ErrorDialogComponent {
  @Input() visible: boolean = false;
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() showRetry: boolean = false;
  @Input() isCancel: boolean = false;

  
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  constructor(private translate: TranslateService) {}

  get resolvedTitle(): string {
    return this.title || this.translate.instant('COMMON.ERROR');
  }

  get resolvedMessage(): string {
    return this.message || this.translate.instant('COMMON.MSG_GENERIC_ERROR');
  }

  onVisibleChange() {
    this.visibleChange.emit(this.visible);
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.close.emit();
  }

  onRetry() {
    this.retry.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }  

}
